import { useTranslation } from 'react-i18next';
import { SUPPORTED_LOCALES, type Locale } from '@etap/shared';
import { setLocale } from '../i18n';
import { api } from '../lib/api';

interface Props {
  className?: string;
  onChange?: (locale: Locale) => void;
}

export function LanguageSwitcher({ className, onChange }: Props) {
  const { i18n, t } = useTranslation();
  const current = (SUPPORTED_LOCALES as readonly string[]).includes(i18n.language)
    ? (i18n.language as Locale)
    : 'ru';

  const handleChange = (loc: Locale) => {
    setLocale(loc);
    if (api.getToken()) {
      api.updateMe({ locale: loc }).catch(() => {
        /* non-blocking */
      });
    }
    onChange?.(loc);
  };

  return (
    <div className={className} role="group" aria-label={t('language.label')} style={{
      display: 'inline-flex',
      gap: 4,
      padding: 4,
      borderRadius: 999,
      background: 'var(--tg-theme-secondary-bg-color, rgba(0,0,0,0.06))',
    }}>
      {SUPPORTED_LOCALES.map((loc) => (
        <button
          key={loc}
          type="button"
          onClick={() => handleChange(loc)}
          style={{
            border: 0,
            cursor: 'pointer',
            padding: '6px 12px',
            borderRadius: 999,
            background: current === loc ? 'var(--tg-theme-button-color, #3b82f6)' : 'transparent',
            color: current === loc ? 'var(--tg-theme-button-text-color, #fff)' : 'var(--tg-theme-hint-color, #888)',
            fontWeight: 600,
            fontSize: 13,
            fontFamily: 'inherit',
          }}
        >
          {loc.toUpperCase()}
        </button>
      ))}
    </div>
  );
}
